export default __webpack_public_path__ + "static/media/DNCC.95824e09.png";